import React from "react";
import { sectionFrame } from "../../config/site";
import { assets } from "../../content/site";
import { SectionHeading } from "../ui/SectionHeading";

export function LocationSection() {
    return (
        <section id="location" className="px-4 pt-[120px] sm:px-6 max-md:pt-[84px]">
            <div className={sectionFrame}>
                <SectionHeading
                    label="Креативный кластер «Квартал Труда» (г. Якутск, улица Труда, дом 1)"
                    title="Где прошла конференция"
                />
                <div className="block overflow-hidden rounded-[20px] transition hover:opacity-95 max-[639px]:mx-auto max-[639px]:h-[325px] max-[639px]:w-full max-[639px]:rounded-[24px]">
                    <img
                        src={assets.map}
                        alt="Карта локации конференции"
                        className="w-full [animation:map-drift_12s_ease-in-out_infinite_alternate] max-[639px]:h-full max-[639px]:object-cover max-[639px]:object-center"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </div>
        </section>
    );
}
